import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/thin-plus.svg'
import _imports_1 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5e24c3aa")

_pushScopeId("data-v-5e24c3aa")
const _hoisted_1 = { class: "business-invoice-page" }
const _hoisted_2 = {
  class: "container",
  style: {"color":"#354052","font-size":"24px","padding-top":"20px"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  id: "desktop-grid",
  class: "desktop-grid"
}
const _hoisted_5 = {
  id: "main-table",
  class: "main-table"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "thead-last-td"
}
const _hoisted_9 = { class: "add-order-product-customer-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = { class: "single-ellipsis" }
const _hoisted_12 = { class: "single-ellipsis" }
const _hoisted_13 = { class: "single-ellipsis" }
const _hoisted_14 = { class: "single-ellipsis" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  style: {"text-align":"end"}
}
const _hoisted_18 = { key: 3 }
const _hoisted_19 = {
  key: 4,
  class: "last-child"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"line-height":"30px","font-weight":"600"} }
const _hoisted_23 = {
  class: "border-footer",
  colspan: "5",
  style: {"padding-inline-start":"20px"}
}
const _hoisted_24 = { class: "border-footer" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "border-footer text-align-end"
}
const _hoisted_27 = {
  key: 1,
  class: "border-footer"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("td", {
  class: "border-footer",
  colspan: "3"
}, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "container"
}
const _hoisted_30 = {
  id: "desktop-grid",
  class: "desktop-grid"
}
const _hoisted_31 = {
  id: "main-table",
  class: "main-table"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "thead-last-td"
}
const _hoisted_34 = { class: "add-order-product-customer-row" }
const _hoisted_35 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_36 = { class: "single-ellipsis" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16 edit-product-icon" }, null, -1)
const _hoisted_39 = { class: "business-invoice-total-row container" }
const _hoisted_40 = { class: "business-invoice-total-box" }
const _hoisted_41 = { class: "amount-value" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "amount-value" }
const _hoisted_45 = { class: "amount-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DocumentHeader = _resolveComponent("DocumentHeader")
  const _component_BusinessAccountingForTo = _resolveComponent("BusinessAccountingForTo")
  const _component_router_link = _resolveComponent("router-link")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_BusinessInvoiceCustomersModal = _resolveComponent("BusinessInvoiceCustomersModal")
  const _component_EditInvoiceProductLine = _resolveComponent("EditInvoiceProductLine")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
    id: "invoice-form-id",
    novalidate: ""
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_DocumentHeader, {
        name: _ctx.invoiceHeader,
        editMode: _ctx.editMode,
        onBack: _ctx.cancel,
        showViewPdf: !_ctx.isNew && !_ctx.editMode,
        showShare: !_ctx.isNew && !_ctx.editMode,
        isNew: _ctx.isNew,
        onShareDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareDocument())),
        onViewPdfDocument: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewPdfDocument())),
        onEdit: _ctx.edit,
        form: 'invoice-form-id',
        showCancelDocument: !!_ctx.clientId && !_ctx.isNew && _ctx.businessInvoice.canCancelDocument,
        cancelButtonText: _ctx.$t('cancelInvoice.cancel-invoice-link'),
        onCancelDocument: _ctx.cancelExistBCPerfomaInvoice
      }, null, 8, ["name", "editMode", "onBack", "showViewPdf", "showShare", "isNew", "onEdit", "showCancelDocument", "cancelButtonText", "onCancelDocument"]),
      _createVNode(_component_BusinessAccountingForTo, {
        editMode: _ctx.editMode,
        isNew: _ctx.isNew,
        recipientNameProp: _ctx.businessInvoice.recipientName,
        forProp: _ctx.businessInvoice.for,
        createdDate: _ctx.businessInvoice.createdDate,
        "issue-date": _ctx.businessInvoice.issueDate,
        "is-invoice": true,
        onUpdateRecipientName: _ctx.updateRecipientName,
        onUpdateFor: _ctx.updateFor,
        onValueDateChanged: _ctx.updateValueDate
      }, null, 8, ["editMode", "isNew", "recipientNameProp", "forProp", "createdDate", "issue-date", "onUpdateRecipientName", "onUpdateFor", "onValueDateChanged"]),
      (_ctx.clientId)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('title.orders')), 1),
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("table", _hoisted_5, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.order_number')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('product.productName')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.coupon-name')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('coupons.customer-type')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.customer_name')), 1)
                      ]),
                      _createVNode("th", null, [
                        (_ctx.type == _ctx.invoiceType.Debit)
                          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('label.left-to-cover-invoice')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('label.covered-by-invoices')), 1))
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('label.created-date')), 1)
                      ]),
                      _createVNode("th", null, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.arrivalDate')), 1)
                      ]),
                      (_ctx.isNew)
                        ? (_openBlock(), _createBlock("th", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("div", {
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addModalCustomers && _ctx.addModalCustomers(...args)))
                              }, [
                                _hoisted_10
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessInvoice.customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: customerIndex }, [
                        _createVNode("td", null, [
                          _createVNode(_component_router_link, {
                            class: "is-link",
                            to: {
                                            name: 'order',
                                            params: { id: customer.orderId }
                                        },
                            target: "_blank"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(customer.orderNumber), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", _hoisted_11, [
                          _createVNode(_component_router_link, {
                            class: "is-link",
                            to: {
                                            name: 'product',
                                            params: { id: customer.productId, tab: 1 }
                                        },
                            target: "_blank"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(customer.productName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            class: "value is-link c-pointer",
                            to: {
                                            name: 'coupon-edit',
                                            params: { couponId: customer.couponId }
                                        },
                            target: "_blank"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(customer.couponName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createVNode("td", _hoisted_13, _toDisplayString(customer.customerTypeName), 1),
                        _createVNode("td", _hoisted_14, _toDisplayString(customer.customerName), 1),
                        (_ctx.isNew)
                          ? (_openBlock(), _createBlock("td", _hoisted_15, _toDisplayString(_ctx.formatAmount(customer.leftToCoverInvoiceInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1))
                          : (_openBlock(), _createBlock("td", _hoisted_16, _toDisplayString(_ctx.formatAmount(customer.leftToCoverInvoice)) + " " + _toDisplayString(customer.currencySymbol), 1)),
                        (_ctx.isNew)
                          ? (_openBlock(), _createBlock("td", _hoisted_17, [
                              (customer.leftToCoverInvoiceInLocal > 0)
                                ? (_openBlock(), _createBlock(_component_InputNumber, {
                                    key: 0,
                                    required: "",
                                    class: "InputNumberByCover",
                                    modelValue: customer.amountToCover,
                                    "onUpdate:modelValue": ($event: any) => (customer.amountToCover = $event),
                                    min: 0,
                                    max: customer.leftToCoverInvoiceInLocal,
                                    allowEmpty: false,
                                    inputId: "locale-us",
                                    locale: "en-US",
                                    useGrouping: true,
                                    suffix: ' ' + _ctx.localCurrencySymbol,
                                    minFractionDigits: 2,
                                    maxFractionDigits: 2
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "suffix"]))
                                : (customer.leftToCoverInvoiceInLocal < 0)
                                  ? (_openBlock(), _createBlock(_component_InputNumber, {
                                      key: 1,
                                      required: "",
                                      class: "InputNumberByCover",
                                      modelValue: customer.amountToCover,
                                      "onUpdate:modelValue": ($event: any) => (customer.amountToCover = $event),
                                      min: customer.leftToCoverInvoiceInLocal,
                                      max: 0,
                                      allowEmpty: false,
                                      inputId: "locale-us",
                                      locale: "en-US",
                                      useGrouping: true,
                                      suffix: ' ' + _ctx.localCurrencySymbol,
                                      minFractionDigits: 2,
                                      maxFractionDigits: 2
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "suffix"]))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("td", _hoisted_18, [
                              _createVNode("span", null, _toDisplayString(_ctx.formatAmount(customer.amountToCover)) + " " + _toDisplayString(customer.currencySymbol), 1)
                            ])),
                        _createVNode("td", null, _toDisplayString(customer.createdDate), 1),
                        _createVNode("td", null, _toDisplayString(customer.arrivalDate), 1),
                        (_ctx.isNew)
                          ? (_openBlock(), _createBlock("td", _hoisted_19, [
                              _createVNode("span", {
                                onClick: ($event: any) => (_ctx.removeRow(customerIndex)),
                                class: "icon"
                              }, [
                                _hoisted_20
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  (_ctx.businessInvoice.customers.length)
                    ? (_openBlock(), _createBlock("tfoot", _hoisted_21, [
                        _createVNode("tr", _hoisted_22, [
                          _createVNode("th", _hoisted_23, _toDisplayString(_ctx.businessInvoice.customers.length) + " " + _toDisplayString(_ctx.$t('title.orders').toLowerCase()), 1),
                          _createVNode("th", _hoisted_24, [
                            (_ctx.isNew)
                              ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.formatAmount(_ctx.totalLeftToCoverInvoiceInLocal)) + " " + _toDisplayString(_ctx.localCurrencySymbol), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.isNew)
                            ? (_openBlock(), _createBlock("td", _hoisted_26, _toDisplayString(_ctx.formatAmount(_ctx.totalAmountToCoverForCustomers.total)) + " " + _toDisplayString(_ctx.totalAmountToCoverForCustomers.symbol), 1))
                            : (_openBlock(), _createBlock("td", _hoisted_27, _toDisplayString(_ctx.formatAmount(_ctx.businessInvoice.customersAmountInLocal)) + " " + _toDisplayString(_ctx.businessInvoice.currencySymbol), 1)),
                          _hoisted_28
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("table", _hoisted_31, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    _createVNode("th", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.itemDescription')), 1)
                    ]),
                    _createVNode("th", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.qty')), 1)
                    ]),
                    _createVNode("th", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.unit')), 1)
                    ]),
                    (!_ctx.isCredit)
                      ? (_openBlock(), _createBlock("th", _hoisted_32, [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.discount')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("th", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.total')), 1)
                    ]),
                    (_ctx.isNew)
                      ? (_openBlock(), _createBlock("th", _hoisted_33, [
                          _createVNode("div", _hoisted_34, [
                            _createVNode("div", {
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addNewLine && _ctx.addNewLine(...args)))
                            }, [
                              _hoisted_35
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessInvoice.products, (product, productIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: productIndex }, [
                      _createVNode("td", _hoisted_36, _toDisplayString(product.name) + "," + _toDisplayString(product.unitName), 1),
                      _createVNode("td", null, _toDisplayString(product.quantity), 1),
                      _createVNode("td", null, _toDisplayString(_ctx.formatAmount(product.pricePerUnit)) + " " + _toDisplayString(product.currencySign), 1),
                      (!_ctx.isCredit)
                        ? (_openBlock(), _createBlock("td", _hoisted_37, _toDisplayString(_ctx.formatAmount(product.discount)) + " " + _toDisplayString(product.currencySign), 1))
                        : _createCommentVNode("", true),
                      _createVNode("td", null, _toDisplayString(_ctx.formatAmount(product.total)) + " " + _toDisplayString(product.currencySign), 1),
                      (_ctx.isNew)
                        ? (_openBlock(), _createBlock("td", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.setItemToEdit(productIndex)),
                            class: "text-end"
                          }, [
                            _hoisted_38
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])),
      _createVNode("div", _hoisted_39, [
        _createVNode("div", _hoisted_40, [
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.total')), 1),
            _createVNode("span", _hoisted_41, _toDisplayString(_ctx.formatAmount(_ctx.businessInvoice.id ? _ctx.businessInvoice.totalAmount : _ctx.productsTotalAmount)) + " " + _toDisplayString(_ctx.totalAmountToCoverForCustomers.symbol), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('label.additional-amount')), 1),
            (_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_InputNumber, {
                  key: 0,
                  class: "extraAmount-input",
                  modelValue: _ctx.businessInvoice.extraAmount,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.businessInvoice.extraAmount = $event)),
                  inputId: "locale-us",
                  locale: "en-US",
                  min: _ctx.clientId ? 0 : undefined,
                  allowEmpty: true,
                  useGrouping: true,
                  suffix: ' ' + _ctx.totalAmountToCoverForCustomers.symbol,
                  minFractionDigits: 2,
                  maxFractionDigits: 2
                }, null, 8, ["modelValue", "min", "suffix"]))
              : (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.formatAmount(_ctx.businessInvoice.extraAmount)) + " " + _toDisplayString(_ctx.totalAmountToCoverForCustomers.symbol), 1))
          ]),
          (_ctx.includeVat)
            ? (_openBlock(), _createBlock("div", _hoisted_43, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('accounting.percentVat', [_ctx.businessInvoice.id ? _ctx.businessInvoice.vatPercent :
                            _ctx.vatPercent])), 1),
                _createVNode("span", _hoisted_44, _toDisplayString(_ctx.formatAmount(_ctx.businessInvoice.id ? _ctx.businessInvoice.vatAmount :
                            _ctx.getVatAmount())) + " " + _toDisplayString(_ctx.totalAmountToCoverForCustomers.symbol), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", null, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.total')), 1),
            _createVNode("span", _hoisted_45, _toDisplayString(_ctx.formatAmount(_ctx.getTotalAmount())) + " " + _toDisplayString(_ctx.totalAmountToCoverForCustomers.symbol), 1)
          ])
        ])
      ]),
      (_ctx.clientId)
        ? (_openBlock(), _createBlock(_component_BusinessInvoiceCustomersModal, {
            key: 2,
            clientId: _ctx.clientId,
            customers: _ctx.customers,
            totalAmount: _ctx.totalAmount,
            localCurrencySymbol: _ctx.localCurrencySymbol,
            amountCoverByInvoces: _ctx.amountCoverByInvoces,
            type: _ctx.type,
            onAddCustomers: _ctx.addCustomers,
            ref: "modalBusinessInvoiceCustomers"
          }, null, 8, ["clientId", "customers", "totalAmount", "localCurrencySymbol", "amountCoverByInvoces", "type", "onAddCustomers"]))
        : _createCommentVNode("", true),
      (_ctx.ShowAddProductLineModal)
        ? (_openBlock(), _createBlock(_component_EditInvoiceProductLine, {
            key: 3,
            itemToEdit: _ctx.itemToEdit,
            isCreditInvoice: _ctx.isCreditInvoice,
            isPerfomaInvoice: _ctx.type == 3,
            onClose: _ctx.closeShowAddProductLineModal,
            onAddProductLine: _ctx.addProductLine,
            onDeleteProductLine: _ctx.deleteProductLine
          }, null, 8, ["itemToEdit", "isCreditInvoice", "isPerfomaInvoice", "onClose", "onAddProductLine", "onDeleteProductLine"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.loaded]
    ])
  ], 32))
})